import { useAtomValue } from 'jotai';
import React from 'react';
import { selectedVisEventsAtom } from '@/atoms/vis/selection';

export const DebugPanel = () => {
  const selectedVisEvents = useAtomValue(selectedVisEventsAtom);

  return (
    selectedVisEvents && (
      <div className="fixed bottom-0 right-0 z-50 text-xs bg-canvas-tertiary-main p-2 max-w-xs max-h-28 overflow-y-auto">
        Selected Video Event IDs: {selectedVisEvents.map(video => video.videoEventId).join(', ')}
      </div>
    )
  );
};
